import { MediaPackGuide, RbcCircleRec } from '@calm/evexia-web-sdk';
import { usePackGuideToProgramGuide } from '@rhg/hooks/use-pack-guide-to-program-guide';
import { LearnWhyButton } from '../learn-why-button';
import { SessionCard, SessionCardProps } from '../session-card';
import StopPropagation from '../stop-propagation';

export interface PackGuideCardProps
    extends Partial<Omit<SessionCardProps, 'guide'>> {
    variant: SessionCardProps['variant']; // Makes this required
    packGuide: MediaPackGuide;
    packClass: string;
    recommendation?: RbcCircleRec;
}
export function PackGuideCard({
    packGuide,
    packClass,
    recommendation,
    ...guideCardProps
}: PackGuideCardProps) {
    const fetchPackProgram = Boolean(recommendation);
    const { program, programGuide, packProgram, isFetched } =
        usePackGuideToProgramGuide(packGuide, packClass, fetchPackProgram);

    if (!programGuide || !isFetched) return null;

    return (
        <SessionCard
            isStandalone
            packClass={packClass}
            program={program}
            session={programGuide}
            additionalAction={
                recommendation ? (
                    <StopPropagation>
                        <LearnWhyButton
                            recommendation={recommendation}
                            program={program}
                            packProgram={packProgram}
                        />
                    </StopPropagation>
                ) : undefined
            }
            {...guideCardProps}
        />
    );
}
